import { useConditionallyMount } from '@/hooks/useConditionallyMount';
import { AddContentModal } from './AddContentModal';
import { useAddContentModalStore } from './store';

export const AddContentModalLoader = () => {
  const { isOpen, reset } = useAddContentModalStore();
  const { mounted, setMounted } = useConditionallyMount(isOpen);

  if (!mounted) {
    return null;
  }

  const handleCloseComplete = () => {
    setMounted(false);
    reset();
  };

  return <AddContentModal onCloseComplete={handleCloseComplete} />;
};
